// Re-export Firestore types/values for use outside firebase-api/.
// Add new re-exports here rather than bypassing the lint rule elsewhere (WEB-102).

export type { DocumentData, DocumentReference } from 'firebase/firestore';
export { Timestamp } from 'firebase/firestore';
